<template>
  <div>
    <vs-popup :title="title" :active.sync="active">
      <div v-html="content"></div>
    </vs-popup>
  </div>
</template>

<script>
import moment from 'moment/moment';
export default {
  data () {
    return {
      active: false,
      content: ""
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
  },
  methods: {
    async handlePopup(objs, action){
      let content = ""
      if(action === "payments"){
        for (const res of objs) {
          let prefix = ""
          if(res.createdBy.prefix){prefix = res.createdBy.prefix.nameTh}
          let createdBy = prefix+res.createdBy.name+" "+res.createdBy.surname
          let paymentDate = res.paymentDate
          let createdAt = res.createdAt
          content += `
            <p>วันที่ชำระเงิน: ${this.convFormatDate(paymentDate)}</p>
            <p>หมายเหตุ: ${res.paymentRemark}</p>
            <p>ผู้บันทึก: ${createdBy} ${this.convFormatDateTime(createdAt)}</p>
            <hr/>
          `
        }
      } else if(action === "callHistories"){
        for (const res of objs) {
          let prefix = ""
          if(res.createdBy.prefix){prefix = res.createdBy.prefix.nameTh}
          let createdBy = prefix+res.createdBy.name+" "+res.createdBy.surname
          let callDate = res.callDate
          let createdAt = res.createdAt
          content += `
            <p>ครั้งที่: ${res.seq}</p>
            <p>วันที่โทร: ${this.convFormatDate(callDate)}</p>
            <p>หมายเหตุ: ${res.remark}</p>
            <p>ผู้บันทึก: ${createdBy} ${this.convFormatDateTime(createdAt)}</p>
            <hr/>
          `
        }
      } else if(action === "sendSmsHistories"){
        for (const res of objs) {
          let prefix = ""
          if(res.createdBy.prefix){prefix = res.createdBy.prefix.nameTh}
          let createdBy = prefix+res.createdBy.name+" "+res.createdBy.surname
          let sendDate = res.sendDate
          let createdAt = res.createdAt
          content += `
            <p>ครั้งที่: ${res.seq}</p>
            <p>วันที่ส่ง SMS: ${this.convFormatDate(sendDate)}</p>
            <p>หมายเหตุ: ${res.remark}</p>
            <p>ผู้บันทึก: ${createdBy} ${this.convFormatDateTime(createdAt)}</p>
            <hr/>
          `
        }
      } else if(action === "sendDocHistories"){
        for (const res of objs) {
          let prefix = ""
          if(res.createdBy.prefix){prefix = res.createdBy.prefix.nameTh}
          let createdBy = prefix+res.createdBy.name+" "+res.createdBy.surname
          let sendDate = res.sendDate
          let createdAt = res.createdAt
          content += `
            <p>ครั้งที่: ${res.seq}</p>
            <p>วันที่ส่งเอกสาร: ${this.convFormatDate(sendDate)}</p>
            <p>หมายเหตุ: ${res.remark}</p>
            <p>ผู้บันทึก: ${createdBy} ${this.convFormatDateTime(createdAt)}</p>
            <hr/>
          `
        }
      } else if (action === "lawsuitHistories"){
        for (const res of objs) {
          let prefix = ""
          if(res.createdBy.prefix){prefix = res.createdBy.prefix.nameTh}
          let createdBy = prefix+res.createdBy.name+" "+res.createdBy.surname
          let lawsuitDate = res.lawsuitDate
          let createdAt = res.createdAt
          content += `
            <p>ครั้งที่: ${res.seq}</p>
            <p>วันที่ส่งฟ้อง: ${this.convFormatDate(lawsuitDate)}</p>
            <p>หมายเหตุ: ${res.remark}</p>
            <p>ผู้บันทึก: ${createdBy} ${this.convFormatDateTime(createdAt)}</p>
            <hr/>
          `
        }
      } else if(action === "suretyDetails"){
        for (const res of objs) {
          let prefix = ""
          if(res.surety.prefix){prefix = res.surety.prefix.nameTh}
          let suretyName = `${prefix}${res.surety.name} ${res.surety.surname}`
          let appointmentDate = res.appointmentDate
          content += `<p>ผู้ค้ำประกันคนที่: ${res.seq}</p>
            <p>เลขที่บัตรประชาชน: ${res.surety.idCardNumber}</p>
            <p>ชื่อ-สกุล: ${suretyName}</p>
            <p>ความเกี่ยวข้อง: ${res.relationship}</p>
            <p>วันที่นัด: ${this.convFormatDate(appointmentDate)}</p>
            <p>รายละเอียด: ${res.appointmentRemark}</p>
            <p><hr/></p>`
        }
      } else if(action === "paymentDetail"){
        const vm = this
        let { paidFee,  paidPenalty, paidInterest, paidPrinciple, balanceRemain } = objs
        content = `
          <p>ยอดชำระค่าธรรมเนียม: ${vm.$options.filters.numberFormat(paidFee)} บาท</p>
          <p>ยอดชำระดอกเบี้ยปรับ: ${vm.$options.filters.numberFormat(paidPenalty)} บาท</p>
          <p>ยอดชำระดอกเบี้ย: ${vm.$options.filters.numberFormat(paidInterest)} บาท</p>
          <p>ยอดชำระเงินต้น: ${vm.$options.filters.numberFormat(paidPrinciple)} บาท</p>
          <p>ยอดชำระดอกเบี้ยล่วงหน้า: ${vm.$options.filters.numberFormat(balanceRemain)} บาท</p>
        `
      }else if(action === "outstandingBalanceRemainDetail"){
         const vm = this
          let { accruedFeeRemain, accruedPenaltyRemain, outstandingAmountRemain } = objs
        const totalOutstandingBalanceRemain = accruedFeeRemain + accruedPenaltyRemain + outstandingAmountRemain
          content = `
            <p>ยอดค่าธรรมเนียมคงเหลือ: ${vm.$options.filters.numberFormat(accruedFeeRemain)} บาท</p>
            <p>ยอดเบี้ยปรับคงเหลือ: ${vm.$options.filters.numberFormat(accruedPenaltyRemain)} บาท</p>
            <p>ยอกเรียกเก็บค้างชำระ: ${vm.$options.filters.numberFormat(outstandingAmountRemain)} บาท</p>
            <p>รวมยอดค้างชำระ: ${vm.$options.filters.numberFormat(totalOutstandingBalanceRemain)} บาท</p>
          `
      }
      this.content = content
      this.active = true
    },
    convFormatDate(val){
      return `${moment(val).format("DD-MM-YYYY")}`
    },
    convFormatDateTime(val){
      return `${moment(val).format("วันที่ DD-MM-YYYY เวลา HH.mm น.")}`
    }
  },
}
</script>

<style>

</style>
